import React from 'react'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
} from '@mui/material'

const ManagerEvaluationPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        上長評価
      </Typography>
      
      <Card>
        <CardContent>
          <Alert severity="info">
            上長評価機能は実装中です。部下の評価リストと評価フォームがここに表示されます。
          </Alert>
        </CardContent>
      </Card>
    </Box>
  )
}

export default ManagerEvaluationPage